import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

import { LessonAddButtonComponent } from './lesson-add-button/lesson-add-button.component';
import { LessonAttachmentDropZoneComponent } from './lesson-attachment-drop-zone/lesson-attachment-drop-zone.component';
import { LessonAttachmentListButtonComponent } from './lesson-attachment-list-button/lesson-attachment-list-button.component';
import { LessonAttachmentListItemComponent } from './lesson-attachment-list-item/lesson-attachment-list-item.component';
import { LessonAttachmentListComponent } from './lesson-attachment-list/lesson-attachment-list.component';
import { LessonEditNavDirective } from './lesson-edit/lesson-edit-nav.directive';
import { LessonEditComponent } from './lesson-edit/lesson-edit.component';
import { LessonListItemComponent } from './lesson-list-item/lesson-list-item.component';
import { LessonListComponent } from './lesson-list/lesson-list.component';
import { LessonRemoveButtonComponent } from './lesson-remove-button/lesson-remove-button.component';
import { LessonNavDirective } from './lesson/lesson-nav.directive';
import { LessonComponent } from './lesson/lesson.component';
import { LessonsRoutingModule } from './lessons-routing.module';
import { LessonAttachmentService } from './shared/lesson-attachment.service';
import { LessonResolver } from './shared/lesson-resolver.service';
import { LessonService } from './shared/lesson.service';

@NgModule({
  imports: [
    SharedModule,
    LessonsRoutingModule
  ],
  declarations: [
    LessonListItemComponent,
    LessonListComponent,
    LessonEditComponent,
    LessonRemoveButtonComponent,
    LessonAddButtonComponent,
    LessonAttachmentDropZoneComponent,
    LessonAttachmentListComponent,
    LessonAttachmentListItemComponent,
    LessonAttachmentListButtonComponent,
    LessonComponent,
    LessonNavDirective,
    LessonEditNavDirective
  ],
  exports: [
    LessonListItemComponent,
    LessonListComponent,
    LessonEditComponent,
    LessonAddButtonComponent,
    LessonComponent
  ],
  providers: [
    LessonService,
    LessonAttachmentService,
    LessonResolver
  ]
})
export class LessonsModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lessons.module.ts